<template>
  <div class="status-bar-wrapper">
    <div v-if="status == 'start' || status == 'wait'" class="text">{{ statusText }}</div>
    <transition name="zoom-up">
      <div v-if="status == 'recognized'" class="content">
        <div class="text">
          <img :src="require('@/assets/img/icon_right.png')" alt="" />
          {{ statusText }}
        </div>
        <div v-if="remark" class="controller date">{{ remark }}</div>
      </div>
    </transition>
    <transition name="zoom-up">
      <div v-if="status == 'unidentification'" class="content">
        <div class="text">
          {{ statusText }}
        </div>
        <el-button class="controller btn" type="primary" @click="$emit('reset')">再次识别</el-button>
      </div>
    </transition>
  </div>
</template>

<script>
import { STATUS_MAP } from './constants';

export default {
  name: 'statusBar',
  props: {
    status: String,
    remark: String
  },
  computed: {
    statusText() {
      const { status } = this;
      switch (status) {
        case STATUS_MAP.START:
          return '人脸识别';
        case STATUS_MAP.WAIT:
          return '正在进行人脸识别...';
        case STATUS_MAP.RECOGNIZED:
          return '已识别';
        case STATUS_MAP.UNIDENTIFICATION:
          return '没有认出你';
        default:
          return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.status-bar-wrapper {
  color: #242424;

  .content {
    text-align: center;
  }

  .text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 600;

    img {
      margin-right: 16px;
      width: 24px;
      height: 24px;
    }
  }

  .date {
    text-align: center;
    font-size: 22px;
  }

  .btn {
    margin-top: 10px;
    width: 174px;
  }

  .zoom-up-enter-active {
    transition: all 3s;

    .text {
      transition: all 1s;
      transform: translateY(0);
    }

    .controller {
      transition: all 0.5s;
      transition-delay: 0.3s;
      opacity: 1;
      transform: translateX(0);
    }
  }

  .zoom-up-enter {
    .text {
      transform: translateY(32px);
    }
    .controller {
      opacity: 0;
      transform: translateY(32px);
    }
  }
}
</style>
